import { Provider, Signal } from "@angular/core";
import {
    ATOM_SEARCH_INPUT_ARIA_LABEL,
    ATOM_SEARCH_INPUT_CLEAR_ARIA_LABEL,
    ATOM_SEARCH_INPUT_COLLAPSED_ARIA_LABEL,
    ATOM_SEARCH_INPUT_PLACEHOLDER,
} from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "atom_search_input";

/**
 * Localizes the default `atom-search-input` labels (placeholder + a11y
 * aria-labels) that instances fall back to when they don't bind the matching
 * input per usage.
 *
 * Tokens are `Signal<string>` and stay in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}. The shortcut letter token is not
 * localized — it is a key, not copy.
 */
export const provideAtomSearchInputLabels = (): Provider[] => [
    {
        provide: ATOM_SEARCH_INPUT_PLACEHOLDER,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.placeholder`),
    },
    {
        provide: ATOM_SEARCH_INPUT_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.aria_label`),
    },
    {
        provide: ATOM_SEARCH_INPUT_CLEAR_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.clear_aria_label`),
    },
    {
        provide: ATOM_SEARCH_INPUT_COLLAPSED_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.collapsed_aria_label`),
    },
];
